@if (hasClinicalData()) {
  @if (allergies().length > 0) {
    <mat-card class="clinical-section-card">
      <mat-card-header>
        <mat-icon mat-card-avatar color="warn">warning</mat-icon>
        <mat-card-title>Allergies</mat-card-title>
        <div class="header-actions">
          <button mat-button color="primary" (click)="toggleAllAllergies(selectedAllergies().size !== allergies().length)">
            {{ selectedAllergies().size === allergies().length ? 'Deselect All' : 'Select All' }}
          </button>
        </div>
      </mat-card-header>
      <mat-card-content>
        @for (allergy of allergies(); track allergy.id) {
          <div class="item-row">
            <mat-checkbox
              [checked]="isAllergySelected(allergy.id)"
              (change)="toggleAllergy(allergy.id, $event.checked)"
              color="primary">
              <div class="item-content">
                <span class="item-primary">{{ allergy.allergy }}</span>
                @if (allergy.comment) {
                  <span class="item-secondary">{{ allergy.comment }}</span>
                }
              </div>
            </mat-checkbox>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }

  @if (medications().length > 0) {
    <mat-card class="clinical-section-card">
      <mat-card-header>
        <mat-icon mat-card-avatar color="primary">medication</mat-icon>
        <mat-card-title>Medications</mat-card-title>
        <div class="header-actions">
          <button mat-button color="primary" (click)="toggleAllMedications(selectedMedications().size !== medications().length)">
            {{ selectedMedications().size === medications().length ? 'Deselect All' : 'Select All' }}
          </button>
        </div>
      </mat-card-header>
      <mat-card-content>
        @for (med of medications(); track med.id) {
          <div class="item-row">
            <mat-checkbox
              [checked]="isMedicationSelected(med.id)"
              (change)="toggleMedication(med.id, $event.checked)"
              color="primary">
              <div class="item-content">
                <span class="item-primary">{{ med.description }}</span>
                @if (med.dosage) {
                  <span class="item-secondary">Dosage: {{ med.dosage }}</span>
                }
              </div>
            </mat-checkbox>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }

  @if (problems().length > 0) {
    <mat-card class="clinical-section-card">
      <mat-card-header>
        <mat-icon mat-card-avatar color="accent">healing</mat-icon>
        <mat-card-title>Problems</mat-card-title>
        <div class="header-actions">
          <button mat-button color="primary" (click)="toggleAllProblems(selectedProblems().size !== problems().length)">
            {{ selectedProblems().size === problems().length ? 'Deselect All' : 'Select All' }}
          </button>
        </div>
      </mat-card-header>
      <mat-card-content>
        @for (problem of problems(); track problem.id) {
          <div class="item-row">
            <mat-checkbox
              [checked]="isProblemSelected(problem.id)"
              (change)="toggleProblem(problem.id, $event.checked)"
              color="primary">
              <div class="item-content">
                <span class="item-primary">{{ problem.problem }}</span>
                @if (problem.comment) {
                  <span class="item-secondary">{{ problem.comment }}</span>
                }
              </div>
            </mat-checkbox>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }

  @if (diagnosis().length > 0) {
    <mat-card class="clinical-section-card">
      <mat-card-header>
        <mat-icon mat-card-avatar color="primary">local_hospital</mat-icon>
        <mat-card-title>Diagnosis Codes</mat-card-title>
        <div class="header-actions">
          <button mat-button color="primary" (click)="toggleAllDiagnosis(selectedDiagnosis().size !== diagnosis().length)">
            {{ selectedDiagnosis().size === diagnosis().length ? 'Deselect All' : 'Select All' }}
          </button>
        </div>
      </mat-card-header>
      <mat-card-content>
        @for (diag of diagnosis(); track diag.icD10Code) {
          <div class="item-row">
            <mat-checkbox
              [checked]="isDiagnosisSelected(diag.icD10Code)"
              (change)="toggleDiagnosis(diag.icD10Code, $event.checked)"
              color="primary">
              <div class="item-content">
                <span class="item-primary">{{ diag.icD10Code }}</span>
                @if (diag.comment) {
                  <span class="item-secondary">{{ diag.comment }}</span>
                }
              </div>
            </mat-checkbox>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }
} @else {
  <mat-card>
    <mat-card-content>
      <div class="empty-clinical">
        <mat-icon>info_outline</mat-icon>
        <span>No clinical data available</span>
      </div>
    </mat-card-content>
  </mat-card>
}
